// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"230":"c9b9cfa4314633a2","350":"d085044c530b33f2","566":"cccf40bf6abc69af","572":"9e88740f5650db5f","597":"e4fe16ab88b662f4","630":"8ddbab98431facc4","717":"0d908971b547522f","834":"06309a9c20e85f07"}[chunkId] + ".js";
};